import React, { useEffect, useState } from 'react'
import styles from './styles.module.css'
import { IoIosEye, IoIosEyeOff, IoIosArrowDown } from 'react-icons/io'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { editFAQ, getMessage } from '../../../actions/FAQ'
import MessageList from '../MessageList'

const dateFormat = 'YYYY-MM-DD, HH:mm'

const Index = ({ item, params }) => {
    const dispatch = useDispatch()
    const [isCollapse, setIsCollapse] = useState(false)
    const [loading, setLoading] = useState(false)
    const { message_list } = useSelector(state => state.FAQ)

    useEffect(() => {
        if (isCollapse && item.id) {
            setLoading(true)
            dispatch(getMessage(item.id)).finally(() => setLoading(false))
        }
    }, [isCollapse])

    const handleHidden = () => {
        dispatch(editFAQ({ hide: Number(!item.hidden), last_viewed: 0 }, params, item.id))
    }

    return (
        <div className={`${styles.card}${item.hidden ? ' ' + styles.hidden : ''}`}>
            <div className={styles.head}>
                <div className={styles.headMain}>
                    <div className={styles.title}>{item.title}</div>
                    <div className={styles.pair}><b>От:</b> {item.from_user}</div>
                    <div className={styles.pair}><b>Кому:</b> {item.to_user}</div>
                </div>
                <div className={styles.headSide}>
                    <div className={styles.stamp}>
                        <b>Создан:</b> {moment(item.created).format(dateFormat)}<br/>
                        <b>Обновлён:</b> {moment(item.updated).format(dateFormat)}
                    </div>
                    <div className={styles.sideActions}>
                        <span className={styles.count}>Сообщений: {item.count}</span>
                        <button
                            className={styles.ic}
                            title={item.hidden ? 'Показать' : 'Скрыть'}
                            onClick={handleHidden}>
                            {item.hidden ? <IoIosEyeOff /> : <IoIosEye />}
                        </button>
                        <button
                            className={styles.ic}
                            title={isCollapse ? 'Свернуть' : 'Развернуть'}
                            style={{ transform: isCollapse ? 'rotate(180deg)' : 'rotate(0deg)', transition: 'transform .2s' }}
                            onClick={() => setIsCollapse(v => !v)}>
                            <IoIosArrowDown />
                        </button>
                    </div>
                </div>
            </div>

            {isCollapse && (
                <MessageList chatId={item.id} data={message_list[item.id]} loading={loading} params={params} />
            )}
        </div>
    )
}

export default Index
